import { initialState } from '../state';
import {
  CurationInfoForPathwaysActionTypes,
  UpdateClinicalTrialsAction
} from '../actions';

export function clinicalTrials(
  state = initialState.clinicalTrials,
  action: UpdateClinicalTrialsAction): any {
  switch (action.type) {
    case CurationInfoForPathwaysActionTypes.UPDATE_CLINICAL_TRIALS:
      return action.payload.nodeIdToClinicalTrials;
    default: {
      return state;
    }
  }
}
